import { IPresets } from 'modules/template-editor/domain/consts/form/presets';

export type TemplatePresetsNameList = 'create' | 'edit' | 'duplicate' | 'copy' | 'delete';

export const templatePresets: Record<TemplatePresetsNameList, IPresets> = {
  create: {
    header: 'Новый шаблон',
    submitButton: 'Создать',
  },
  edit: {
    header: 'Редактирование шаблона',
    submitButton: 'Сохранить',
  },
  duplicate: {
    header: 'Дублирование шаблона',
    submitButton: 'Создать',
  },
  copy: {
    header: 'Копирование шаблона',
    submitButton: 'Скопировать',
  },
  delete: {
    header: 'Удаление шаблона',
    submitButton: 'Удалить',
  },
};
